import React  from 'react'
// import Overlay from "./components/Sections/Overlay";
import { BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Hero from './pages/Hero';
import Dashboard from './pages/Dashboard';
import CvReview from './pages/CvReview';
import Uploaded from './components/uploads/Uploaded';
import Saved from './components/uploads/Saved';
import AllTutorials from './components/tutorial/AllTutorials'
import FavouriteTutorials from './components/tutorial/FavouriteTutorials';
import MyTutorials from './components/tutorial/MyTutorials';
import TutorialAbout from './components/tutorial/tutorialAbout';
import Interview from './pages/Interview';
import Profile from './pages/user/UserProfile';
import Tutoring from './pages/user/tutoring';
import TutorRegister from './pages/TutorRegister';

function App() {

  return (
    <>
    <Router>
      <Routes>
        <Route path="/" element={<Hero/>} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/cvreview" element={<CvReview />} />
        <Route path="/uploaded" element={<Uploaded />} />
        <Route path="/saved" element={<Saved />} />
        <Route path='/registerTutor' element = {<TutorRegister />}/>
        <Route path= "/tutorials" element = {<AllTutorials />} />
        <Route path= "/mytutorials" element = {<MyTutorials />} />
        <Route path= "/myfavourites" element = {<FavouriteTutorials />} />
        <Route path= "/tutorial" element = {<TutorialAbout />} />
        <Route path='/interview' element = {<Interview />}/>
        <Route path= "tutorials/tutorial/:id" element = {<TutorialAbout />} />
        <Route path= "user/profile" element = {<Profile />} />
        <Route path= "user/tutoring" element = {<Tutoring />} />
      </Routes>
    </Router>
    </>
  );
}

export default App;
